import { Tooltip } from 'antd'
import { MdOutlineWifiProtectedSetup } from 'react-icons/md'

export default function SynchronizingIndicator() {
  return (
    <Tooltip title='Sincronización de datos en curso' placement='bottom'>
      <MdOutlineWifiProtectedSetup className='indicator synchronizing' />
    </Tooltip>
  )
}
